import React from 'react';
import { Container, Typography, Grid, LinearProgress, Link, Rating, Button, IconButton, Chip} from '@mui/material';

import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import GitHubIcon from '@mui/icons-material/GitHub';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import WorkIcon from '@mui/icons-material/Work';

import myImage_ from '../assests/images/education/college2.jpg';
import myImage2_ from '../assests/images/education/spce.png';
import styled from 'styled-components';
import { faGraduationCap } from '@fortawesome/free-solid-svg-icons';
import { faLaptopCode } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import "../css/style.css"

const Profile = () => {

const linkedInProfile = "https://www.linkedin.com/in/ameyasgidh/"; 
const location = 'Boston, USA'; 

const facebookProfile = "https://www.facebook.com/ameya.gidh/"; 
const twitterProfile = "https://twitter.com/GidhAmeya";
const instagramProfile = "https://www.instagram.com/ameyagidh2/"; 
const githubProfile = "https://github.com/ameyagidh"; 

const RotatingImage = styled.img`
position: 'absolute',
width: '100%',
height: '100%',
objectFit: 'cover',
borderRadius: '50%',
boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
border: '4px solid #fff',
`;

const skills = [
  { name: 'Python', rating: 4.5 },
  { name: 'Java', rating: 4 },
  { name: 'SQL', rating: 4 },
  { name: 'MERN Stack', rating: 4.5 },
  { name: 'Cloud Deployment', rating: 4 },
  { name: 'API Development', rating: 4 },

];

const halfskillsLength = skills.length/2;

 return (

<Container sx={{ paddingTop: '80px', paddingBottom: '80px' }} id='profile' xs='auto'>
<Grid container spacing={3}>
<Grid item xs={12} md={6}>
<section className="education" id="education" style={{ marginBottom: '40px' }}>
  <h2 style={{ textAlign: 'center', marginBottom: '20px' }}><FontAwesomeIcon icon={faGraduationCap} size="xs" /> Education</h2>
  <div className="box-container">
    <div className="box" style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #ccc', paddingBottom: '30px' }}>
      <div className="image" style={{ width: '80px', height: '80px', marginRight: '20px' }}>
        <RotatingImage
          src={myImage_}
          alt="khoury College of Computer Science Northeastern University"
          style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }}
        />
      </div>
      <div className="content">
        <Typography variant="body3" style={{ marginBottom: '5px' }}>
          Masters of Science in Computer Science 
        </Typography>
        <Typography variant="body2" style={{ marginBottom: '5px' }}>
          Northeastern University, Khoury College of Computer Science
        </Typography>
        <Typography variant="subtitle2">
          <b>2021 - 2024</b>
        </Typography>
      </div>
    </div>

    <div className="box" style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #ccc', paddingBottom: '30px' }}>
      <div className="image" style={{ width: '80px', height: '80px', marginRight: '20px' }}>
        <RotatingImage
          src={myImage2_}
          alt="Sardar Patel College of Engineering"
          style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }}
        />
      </div>
      <div className="content">
        <Typography variant="body3" style={{ marginBottom: '5px' }}>
          Bachelors of Technology 
        </Typography>
        <Typography variant="body2" style={{ marginBottom: '5px' }}>
          Sardar Patel College of Engineering
        </Typography>
        <Typography variant="subtitle2">
          <b>2017 - 2021</b>
        </Typography>
      </div>
    </div>
  </div>
</section>


{/* <div style={{ marginBottom: '120px' }}></div> */}

<h2 style={{ textAlign: 'center', marginBottom: '20px' }}><FontAwesomeIcon icon={faLaptopCode} size="xs" /> Skills</h2>
          <Grid container spacing={3}>
            {/* Main skills grid */}
            <Grid item xs={12} md={6}>
              {skills.slice(0, halfskillsLength).map((skill) => (
                <div key={skill.name}>
                  <Typography variant="subtitle2">{skill.name}</Typography>
                  <Rating value={skill.rating} readOnly />
                  <LinearProgress
                    variant="determinate"
                    value={(skill.rating / 5) * 100}
                    sx={{ marginBottom: '10px' }}
                  />
                </div>
              ))}
            </Grid>
            {/* Additional skills grid */}
            <Grid item xs={12} md={6}>
              {skills.slice(halfskillsLength).map((skill) => (
                <div key={skill.name}>
                  <Typography variant="subtitle2">{skill.name}</Typography>
                  <Rating value={skill.rating} readOnly />
                  <LinearProgress
                    variant="determinate"
                    value={(skill.rating / 5) * 100}
                    sx={{ marginBottom: '10px' }}
                  />
                </div>
              ))}
            </Grid>
          </Grid>

</Grid>
<Grid item xs={12} md={6}>
<Typography variant="h4" gutterBottom>
           Ameya Santosh Gidh
</Typography>
<Grid container spacing={1} sx={{ marginTop: '20px' }}>
<Grid item>
</Grid>
<Grid item>
<Typography variant="body2" sx={{ fontSize: 'small' }}>
<h2 style={{ textAlign: 'center', marginBottom: '20px' }}><FontAwesomeIcon icon={faGraduationCap} size="xs" /> Graduate Student at Northeastern University </h2>
</Typography>
</Grid>
</Grid>
<Grid container spacing={1} sx={{ marginTop: '10px' }}>
<Grid item>
<LocationOnIcon fontSize="small" />
</Grid>
<Grid item>
<Typography variant="body2" sx={{ fontSize: 'small' }}>
           {location}
</Typography>
</Grid>
</Grid>

<Typography variant="body1" align="justify" sx={{ marginBottom: '20px', lineHeight: '1.6' }} fontStyle='normal'>
<j>Hello, I'm Ameya Santosh Gidh, a dedicated Software Developer and Data Science Enthusiast with a Master's in Computer Science from Khoury College of Computer Science Northeastern University, Boston. Proficient in Python and SQL, my passion revolves around Machine Learning and Artificial Intelligence. Leveraging my background in Mechanical Engineering, I've also cultivated expertise in Supply Chain dynamics.

Feel free to explore my projects, and should any pique your interest, I welcome you to reach out. I'm eager to connect with like-minded individuals and foster meaningful collaborations within our shared passion for data-driven innovation.</j>
&nbsp;
<b>Let's connect on LinkedIn for further insights and collaborations </b>
</Typography>

<div class="box-container" style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gridGap: '10px' }}>
  <div class="box" style={{padding: '10px' }}>
    <p><span style={{ fontWeight: 'bold' }}>Age:</span> 24</p>
  </div>
  <div class="box" style={{padding: '10px' }}>
    <p><span style={{ fontWeight: 'bold' }}>Phone:</span> +1 857 437 9760</p>
  </div>
  <div class="box" style={{padding: '10px' }}>
    <p><span style={{ fontWeight: 'bold' }}>Email:</span> ameyagidh2@gmail.com</p>
  </div>
  <div class="box" style={{padding: '10px' }}>
    <p><span style={{ fontWeight: 'bold' }}>Location:</span> Boston</p>
  </div>
</div>



<Link href={linkedInProfile} target="_blank" rel="noreferrer">
<IconButton>
<LinkedInIcon />
</IconButton> {"My Linkedin"}
</Link>
<Link href={githubProfile} target="_blank" rel="noreferrer">
    <IconButton>
      <GitHubIcon/>
    </IconButton> 
    {"Github"}
  </Link>
  <Link href={facebookProfile} target="_blank" rel="noreferrer">
    <IconButton>
      <FacebookIcon />
    </IconButton> 
    {"Facebook"}
  </Link>
<Link href={instagramProfile} target="_blank" rel="noreferrer">
    <IconButton>
      <InstagramIcon />
    </IconButton> 
    {"Instagram"}
  </Link>
  <Link href={twitterProfile} target="_blank" rel="noreferrer">
    <IconButton>
      <TwitterIcon />
    </IconButton> 
    {"Twitter"}
  </Link>
</Grid>
</Grid>
</Container>
 );
};
export default Profile;